<template>
  <div class="app-container">
    组织架构管理
    <!-- <div class="info-box">
      <dp-tree
        ref="dp_tree"
        show-action="Edit|Delete"
        @on-select="onSelect"
        @title-click="titleClick"
      />
      <div style="margin-left: 10px;width: 100%;">
        <list ref="list">
          <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button
              type="primary"
              :disabled="select.Id==null"
              @click="create"
              icon="el-icon-plus"
            >添加</el-button>
            <el-button type="danger" @click="delRows">删除</el-button>
          </template>
          <template slot="column">
            <el-table-column label="操作" fixed="right" align="center" width="140">
              <template slot-scope="{row}">
                <el-button v-if="$permission.canWrite()" type="text" @click="edit(row)">编辑</el-button>
              </template>
            </el-table-column>
          </template>
        </list>
      </div>
    </div>
    <edit-dialog ref="editDialog" @close-saved="reload" /> -->
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/ent/emp/list";
import dpTree from "@/components/basedata/personnel/dp/tree";

import editDialog from "@/components/basedata/personnel/dp/editDialog";

export default {
  name: "ent",
  // mixins: [curdMixins],
  components: {
    list,
    dpTree,
    editDialog,
  },
  data() {
    return {
      select: {
        Id: null,
        Name: "",
      },
    };
  },
  methods: {
    onSelect(data) {
      console.log("onSelect", data);
      this.select.Id = data.DpId;
      this.select.Name = data.DpName;
      this.$refs.list.getData({ DpId: data.DpId });
      // this.reload();
    },
    titleClick() {
      this.select.Id = null;
      this.select.Name = "";
      this.$refs.list.getData({ DpId: null });
    },
    create() {
      this.$refs.editDialog.openCreate({
        DpId: this.select.Id,
        DpName: this.select.Name,
      });
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.EmpId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
.info-box {
  display: flex;
  display: -webkit-flex;
  display: -webkit-inline-flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
}
</style>